import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
// import { SharedModule } from "../modules/shared.module";
import { BarcodeRouteModule } from "./barcode.route";
import { BarcodeComponent } from "./barcode.component";
import { InstantSearchComponent } from "./instant-search/instant-search.component";
import { InputFieldComponent } from "./input-field/input-field.component";
import { MediaStreamComponent } from "./media-stream/media-stream.component";
import { BarcodeValidatorService } from "./services/barcode-validator.service";
import { BarcodeDecoderService } from "./services/barcode-decoder.service";

@NgModule({
  imports: [
    // SharedModule,
    BarcodeRouteModule,
    CommonModule
  ],
  exports: [
    BarcodeComponent,
    InstantSearchComponent,
    InputFieldComponent,
    MediaStreamComponent
  ],
  declarations: [
    BarcodeComponent,
    InstantSearchComponent,
    InputFieldComponent,
    MediaStreamComponent,
  ],
  providers: [
    BarcodeValidatorService,
    BarcodeDecoderService
  ]
})

export class BarcodeModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/barcode/barcode.module.ts